import "./style.css"

function Field({ label, value, holder, field, setInfo }) {
    return (
        <div className="field">
            <span className="label">{label} :</span>
            <input
                placeholder={holder}
                value={value}
                onChange={(e) => setInfo(field, e)}
            />
        </div>
    )
}

export default Field;